<template>
  <main class="">
    <elNavbar />
    <!-- Start Banner Hero -->
    <section class="bg-light">
      <div class="container py-4">
        <!-- TODO: @hamid = Add content-->
        <h1>How to use site</h1>
      </div>
    </section>
    <elFooter />
  </main>
</template>

<script>
import elFooter from "../components/Footer.vue";
import elNavbar from "../components/Navbar.vue";

export default {
  name: "HowTo",
  metaInfo: {
    title: "How to use",
    titleTemplate: "%s | NEW ABC APP",
  },
  components: {
    elFooter,
    elNavbar,
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },
  methods: {},
};
</script>

